/** 업데이트 소식 문구 — ko/landingReleases.ts 와 같은 키(정본은 ko). */
const landingReleases = {
  "eyebrow": "What's new",
  "title": "The latest from DroneSquare",
  "lead": "Be the first to see DroneSquare's most advanced site technology.",
  "demo": "Watch the demo",
  "demoLabel": "Watch the demo — {{topic}}",
  "demoStepLabel": "Watch the demo — {{topic}}, from step {{step}}",
  "artLabel": "Illustration: {{title}}",
  "items": {
    "auto_mapping": {
      "title": "GCP auto-detection",
      "description": "Finds standard markers on its own and builds the map with no control-point work."
    },
    "equip_sim": {
      "title": "Equipment route simulation",
      "description": "Move several machines at real size and spot collision risks in advance."
    },
    "linear_ew": {
      "title": "Alignment-based earthwork",
      "description": "One alignment gives cut and fill volumes at every station."
    },
    "ew_summary": {
      "title": "3D earthwork calculation",
      "description": "Compares drawings with 3D to calculate planned, completed and remaining volumes automatically."
    },
    "folders": {
      "title": "Folders for all your data",
      "description": "However many files you have, folders keep them one click away."
    },
    "walk_roadview": {
      "title": "360° road view",
      "description": "Walk the site in 360° photos without leaving the office."
    },
    "history": {
      "title": "Project history",
      "description": "Creations, edits and deletions are logged in time order, ready to trace."
    },
    "area_capture": {
      "title": "Area capture",
      "description": "Cut out just the area you need as a high-resolution image."
    },
    "issue_comments": {
      "title": "Issue comments",
      "description": "Comments and site photos keep the field and the office on the same issue."
    },
    "pano360": {
      "title": "360° photo and video viewer",
      "description": "Look around the site in every direction with 360° photos and videos."
    },
    "clip_box": {
      "title": "3D clipping tool",
      "description": "Slice into 3D models to measure and record what is hidden inside."
    },
    "dsm_color": {
      "title": "3D elevation colors",
      "description": "Height colors make the highs and lows of 3D terrain clear at a glance."
    },
    "vectors": {
      "title": "3D vectors by coordinates",
      "description": "3D lines are drawn on the site exactly along your design coordinates."
    },
    "workers": {
      "title": "Worker location monitoring",
      "description": "See workers in real time and get alerted the moment they enter a restricted zone."
    },
    "first_person": {
      "title": "First-person flight",
      "description": "Fly through the 3D site and inspect every corner."
    },
    "geolog_map": {
      "title": "GeoLog",
      "description": "Photos and videos land on the map exactly where they were taken."
    },
    "ja": {
      "title": "Japanese and Khmer support",
      "description": "Four languages and local time zones let you run overseas sites on the same screen."
    },
    "dxf_on_3d": {
      "title": "Drawing overlay on 3D",
      "description": "Drape design drawings over 3D terrain to compare design and site in three dimensions."
    },
    "profile_3d": {
      "title": "3D longitudinal and cross sections",
      "description": "Check the 3D model's longitudinal and cross sections along the alignment instantly."
    }
  }
} as const;

export default landingReleases;
